export default {
  title: "404",
  subtitle: "不明なページ",
  message: "お探しのアーティストは販売準備中か販売終了された場合がございます。<br>現在ブックマークをされている方は、次回販売がある場合、同じURLとなります。<br>販売に関する告知情報をご確認ください。",
  return_top: "TOPに戻る",
};